<!-- <select id="sort-by" (change)="sort($event)">
  <option value="" selected disabled hidden>Sort By</option>
  <option value="Low" >Show Low to High Price</option>
</select> -->
<div class="plans" [class.has-recommended]="hasRecommendedPlan">
  <div
    class="plan"
    *ngFor="let plan of defaultPlan; last as last; first as first"
    [class.recommended]="plan.recommended"
    [class.last]="last"
    [class.first]="first"
  >
    <div class="name" trans>
      {{ plan.name }}
    </div>

    <div class="recommended-tag" *ngIf="plan.recommended" trans>Recommended</div>

    <div class="price-box" *ngIf="!plan.free">
      <span class="number">{{ plan.amount | currency : plan.currency }}</span>
      <span class="interval"> / {{ plan.interval | trans }}</span>
    </div>

    <div class="price-box" *ngIf="plan.free" trans>Free</div>

    <plan-features-list [plan]="plan"></plan-features-list>
    
    <div class="choose-plan-button">
      <button
        class="select-plan-button"
        (click)="selectPlan(plan)"
        mat-stroked-button
        color="accent"
        [disabled]="shouldDisablePlanSelection(plan)"
      >
        {{ selectPlanButtonText(plan) | trans }}
      </button>
    </div>
  </div>
</div>

<!-- <div *ngIf="ifRegistered()">Registered</div>
<div *ngIf="!ifRegistered()">Not Registered</div> -->
